import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Parametres.css';
import AccueilButtons from './Components/Accueil-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';

function Parametres() {
    const [showRectangle, setShowRectangle] = useState(false);
    const [showRobert, setShowRobert] = useState(false);
    const [showContactInfo, setShowContactInfo] = useState(false);
    const [showTexte, setShowTexte] = useState(false);
    const navigate = useNavigate();

    // Fonction pour afficher les informations de contact
    const contactInfo = () => {
        return (
            <div className={`contact-info ${showContactInfo ? 'show' : ''}`}>
                <p>
                    2121 rue Parthenais<br />
                    Montréal, QC H2K 3T1<br /><br />
                    Bureau : <a href="tel:+15145285430">(514) 528-5430</a><br />
                    Fax : <a href="tel:+15145285881">(514) 528-5881</a><br />
                    Courriel : <a href="mailto:info@lni.ca">info@lni.ca</a><br />
                    Site Web : <a href="https://lni.ca" target="_blank" rel="noopener noreferrer">lni.ca</a>
                </p>
    
                <div className="social-links">
                    <a href="https://facebook.com/theatreLNI" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faFacebook} className="social-icon" />
                    </a>
                    <a href="https://www.instagram.com/lni_officiel/" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faInstagram} className="social-icon" />
                    </a>
                    <a href="https://linkedin.com/company/theatreLNI" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
                    </a>
                    <a href="https://youtube.com/theatreLNI" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faYoutube} className="social-icon" />
                    </a>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const timers = [
            setTimeout(() => setShowRectangle(true), 250),
            setTimeout(() => setShowRobert(true), 1100),
            setTimeout(() => setShowTexte(true), 1100),
            setTimeout(() => setShowContactInfo(true), 1100),
        ];

        return () => timers.forEach(timer => clearTimeout(timer));
    }, []);

    const handleLogout = () => {
        // Effacer l'ID utilisateur du stockage local
        localStorage.removeItem('userId');
        // Rediriger vers la page de connexion
        navigate('/Connexion');
    };

    return (
        <div className="Parametres-container">
            {/* Rectangles divers */}
            <div className="Rectangle56"></div>
            <div className="Rectangle102"></div>
            <div className="Rectangle103"></div>
            <div className="Rectangle114"></div>
            <div className="Rectangle109"></div>
            <div className="Rectangle110"></div>
            <div className="Rectangle108"></div>
            <div className="Rectangle107"></div>
            <div className="Rectangle104"></div>
            <div className="Rectangle101"></div>
            <div className="Rectangle78"></div>
            <div className="Rectangle111"></div>
            <div className="Rectangle106"></div>
            <div className="Int">.Int</div>
            <div className={`Rectangle188 ${showRectangle ? 'show' : ''}`}></div>
            <div className={`Rectangle189 ${showRobert ? 'show' : ''}`}></div>
            <div className={`Rectangle190 ${showRobert ? 'show' : ''}`}></div>
            <div className={`Rectangle191 ${showRectangle ? 'show' : ''}`}></div>
            <div className={`Rectangle8-1 ${showTexte ? 'show' : ''}`}></div>
            <div className={`Rectangle9-1 ${showTexte ? 'show' : ''}`}></div>
            <div className={`Texte11 ${showTexte ? 'show' : ''}`}>
                Coordonnées
            </div>
            <div className={`Texte12 ${showTexte ? 'show' : ''}`}>
              Propulsé par
            </div>

            {/* Appel à la fonction pour afficher les informations de contact */}
            {contactInfo()}

            {/* Bouton de déconnexion */}
            <button onClick={handleLogout} className="logout-button">
                Déconnexion
            </button>

            {/* Boutons de navigation */}
            <AccueilButtons />
        </div>
    );
}

export default Parametres;
